import * as world from "./world.json"
import * as sherlock from "./sherlock.json"

export default {
  world,
  sherlock
};